<mat-form-field class="col-12">
  <mat-label style="padding: 2px 7px;
  margin-top: -13px;
  background-color: #fff;
  margin-left: 7px;" >{{ translateMutliSelectFieldName(fieldObject) }}</mat-label>
  <mat-select class="form-control" style="margin-top: -20px;" [style.height]="!inputHeight?'40px':inputHeight" [formControl]="formControlRef" multiple>
    <mat-select-trigger>
      {{formControlRef.value ? formControlRef.value[0] : ''}}
      <span *ngIf="formControlRef.value?.length > 1" >
        (+{{formControlRef.value.length - 1}} {{formControlRef.value?.length === 2 ? 'other' : 'others'}})
      </span>
    </mat-select-trigger>
    <mat-option *ngFor="let fieldValue of fieldObject.fieldValues" [value]="fieldValue.name">{{ fieldValue.name }}</mat-option>
  </mat-select>
  <mat-error *ngIf="fieldErrors[fieldObject.fieldName] || fieldErrors[fieldErrorName]">
      {{ fieldErrors[fieldObject.fieldName] || fieldErrors[fieldErrorName] }}
  </mat-error>
</mat-form-field>
